"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderListForWebform = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _shopeeCommon = require("@mkt-common/shopee-common");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Modal = require("../Modal/Modal");
var _ProductList = require("../ProductList");
var _LocaleProvider = require("../LocaleProvider");
var _Popup = require("../Popup");
var _http = _interopRequireWildcard(require("../../api/http"));
var _constants = require("../../utils/constants");
var _getHost = require("../../utils/getHost");
var _formatPrice = require("../../utils/formatPrice");
var _bodyScrollLock = require("body-scroll-lock");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
console.log('getReturnList, getOrderList', _http.getReturnList, _http.getOrderList, _constants.AUTH_TYPE, _constants.AUTH_BIZ_NAME);
var OrderListForWebform = function OrderListForWebform(props) {
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans,
    region = _useLocale.region;
  var selectOrderText = props.selectOrderText,
    onButtonClick = props.onButtonClick,
    _props$isActive = props.isActive,
    isActive = _props$isActive === void 0 ? false : _props$isActive,
    onClose = props.onClose,
    _props$showType = props.showType,
    showType = _props$showType === void 0 ? 'popup' : _props$showType,
    _props$env = props.env,
    env = _props$env === void 0 ? 'live' : _props$env,
    _props$cid = props.cid,
    cid = _props$cid === void 0 ? region || 'sg' : _props$cid,
    token = props.token;
  var prefixCls = (0, _getPrefixCls.getPrefixCls)('order-list-webform');
  var buyerTitles = [{
    name: trans(_constants.ALL_TEXT),
    type: _constants.TYPE_ALL
  }, {
    name: trans(_constants.TO_PAY_TEXT),
    type: _constants.BUYER_QUERY_TYPE.toPay
  }, {
    name: trans(_constants.TO_SHIP_TEXT),
    type: _constants.BUYER_QUERY_TYPE.toShip
  }, {
    name: trans(_constants.TO_RECEIVE_TEXT),
    type: _constants.BUYER_QUERY_TYPE.toReceive
  }, {
    name: trans(_constants.COMPLETED_TEXT),
    type: _constants.BUYER_QUERY_TYPE.completed
  }, {
    name: trans(_constants.CANCELLED_TEXT),
    type: _constants.BUYER_QUERY_TYPE.cancelled
  }, {
    name: trans(_constants.RETURN_REFUND_TEXT),
    type: _constants.RETURN_REFUND_TYPE
  }];
  var sellerTitles = [{
    name: trans(_constants.ALL_TEXT),
    type: _constants.TYPE_ALL
  }, {
    name: trans(_constants.UNPAID_TEXT),
    type: _constants.SELLER_QUERY_TYPE.unPaid
  }, {
    name: trans(_constants.TO_SHIP_TEXT),
    type: _constants.SELLER_QUERY_TYPE.toShip
  }, {
    name: trans(_constants.SHIPPING_TEXT),
    type: _constants.SELLER_QUERY_TYPE.shipped
  }, {
    name: trans(_constants.COMPLETED_TEXT),
    type: _constants.SELLER_QUERY_TYPE.completed
  }, {
    name: trans(_constants.SELLER_CANCELLED_TEXT),
    type: _constants.SELLER_QUERY_TYPE.cancelled
  }, {
    name: trans(_constants.SELLER_RETURN_REFUND_TEXT),
    type: _constants.RETURN_REFUND_TYPE
  }];
  var userTypes = [{
    name: trans(_constants.BUYER_ORDER_LIST_TITLE_TEXT),
    type: _constants.USERTYPE.Buyer
  }, {
    name: trans(_constants.SELLER_ORDER_LIST_TITLE_TEXT),
    type: _constants.USERTYPE.Seller
  }];
  var _useState = (0, _react.useState)(buyerTitles),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    tab = _useState2[0],
    setTab = _useState2[1];
  var scrollTop = (0, _react.useRef)(0);
  var initActiveFlag = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    _http.default.defaults.baseURL = (0, _getHost.getChatbotHost)({
      env: env
    });
    _http.default.interceptors.request.use(function (config) {
      config.headers = _objectSpread(_objectSpread({}, config.headers), {}, {
        'shopee-region': cid
      });
      return _objectSpread({}, config);
    });
  }, []);
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      var targetElement = document.querySelector('.ChatbotUI-tabs');
      if (isActive) {
        initActiveFlag.current = true;
        targetElement && (0, _bodyScrollLock.disableBodyScroll)(targetElement, {
          allowTouchMove: function allowTouchMove() {
            return true;
          }
        });
        scrollTop.current = document.documentElement.scrollTop;
        document.body.style.height = '101vh';
        document.documentElement.scrollTop = scrollTop.current || 1;
      } else {
        if (initActiveFlag.current) {
          targetElement && (0, _bodyScrollLock.enableBodyScroll)(targetElement);
          document.body.style.height = 'inherit';
          document.documentElement.scrollTop = scrollTop.current || 0;
          initActiveFlag.current = false;
        }
      }
    }, 0);
    return function () {
      (0, _bodyScrollLock.clearAllBodyScrollLocks)();
    };
  }, [isActive]);
  var onMainTabClick = function onMainTabClick(type) {
    setTab(type === _constants.USERTYPE.Seller ? sellerTitles : buyerTitles);
  };
  var formatOrderList = function formatOrderList(orderList, isRR) {
    var data = orderList.map(function (order) {
      var _order$items;
      var item = ((_order$items = order.items) === null || _order$items === void 0 ? void 0 : _order$items[0]) || {};
      var orderImg = (item === null || item === void 0 ? void 0 : item.image[0]) || '';
      return {
        title: item.title,
        specification: item.specification,
        orderId: order.order_id,
        orderSn: order.order_sn,
        orderStatusText: isRR ? order.return_status : trans(_constants.orderListTypeToText[order.order_list_type]),
        totalPaymentText: isRR ? trans(_constants.REFUND_AMOUNT_TEXT) : trans(_constants.TOTAL_PAYMENT_TEXT),
        amount: item.amount,
        orderPrice: (0, _formatPrice.formatPrice)(cid, item.order_price),
        totalPrice: isRR ? (0, _formatPrice.formatPrice)(cid, order.refund_amount) : (0, _formatPrice.formatPrice)(cid, order.total_price),
        itemCount: order.item_count,
        image: (0, _shopeeCommon.cdnFile)(orderImg),
        shopName: order.shop_name
      };
    });
    return {
      data: data
    };
  };
  var loadMore = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(params) {
      var getListFun, res, _res$data;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getListFun = params.status === _constants.RETURN_REFUND_TYPE ? _http.getReturnList : _http.getOrderList;
              _context.next = 3;
              return getListFun(_objectSpread(_objectSpread(_objectSpread({}, params), {
                order_list_type: params.status,
                user_kind: params.user_type
              }), {}, {
                auth: {
                  biz_name: _constants.AUTH_BIZ_NAME,
                  type: _constants.AUTH_TYPE,
                  shopee_spec_token: token
                }
              }));
            case 3:
              res = _context.sent;
              if (!(res instanceof Error)) {
                _context.next = 8;
                break;
              }
              return _context.abrupt("return", {
                data: []
              });
            case 8:
              return _context.abrupt("return", formatOrderList((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.order_list) || [], params.status === _constants.RETURN_REFUND_TYPE ? true : false));
            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function loadMore(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-container")
  }, showType === 'modal' ? /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    title: trans(_constants.SELECT_ORDER_TEXT),
    showCloseIcon: true,
    active: isActive,
    onClose: onClose,
    className: "".concat(prefixCls, "-modal__container"),
    zIndex: 9999,
    titleClassName: "".concat(prefixCls, "-modal__title"),
    contentClassName: "".concat(prefixCls, "-modal__content"),
    contentContainerClassName: "".concat(prefixCls, "-modal")
  }, /*#__PURE__*/_react.default.createElement(_ProductList.ProductListTabs, {
    tabs: tab,
    onLoadMore: loadMore,
    selectOrderText: selectOrderText,
    showUserTypeTab: true,
    userTypes: userTypes,
    showOrderId: true,
    onButtonClick: onButtonClick,
    onMainTabClick: onMainTabClick
  })) : /*#__PURE__*/_react.default.createElement(_Popup.Popup, {
    title: trans(_constants.SELECT_ORDER_TEXT),
    showCloseIcon: true,
    active: isActive,
    onClose: onClose,
    className: "".concat(prefixCls, "-popup__container"),
    zIndex: 9999,
    titleClassName: "".concat(prefixCls, "-popup__title"),
    contentClassName: "".concat(prefixCls, "-popup__content")
  }, /*#__PURE__*/_react.default.createElement(_ProductList.ProductListTabs, {
    tabs: tab,
    onLoadMore: loadMore,
    selectOrderText: selectOrderText,
    showUserTypeTab: true,
    userTypes: userTypes,
    showOrderId: true,
    onButtonClick: onButtonClick,
    onMainTabClick: onMainTabClick
  })));
};
exports.OrderListForWebform = OrderListForWebform;